import {
  roomStageIdsMap,
  roomStepIdsMap,
  roomAcceptanceStatusIdsMap,
} from '../../../../../constants/room/lifeCycle';

const steps = new Set([
  roomStepIdsMap.readyForAcceptance,
  roomStepIdsMap.invite,
]);

export const hideService = (record) => {
  const {
    stageAddressLifeCycle,
    stepAddressLifeCycle,
    recordInfo: { acceptanceStatusAddressLifeCycle } = {},
  } = record;

  return (
    stageAddressLifeCycle.id === roomStageIdsMap.acceptance &&
    steps.has(stepAddressLifeCycle.id) &&
    acceptanceStatusAddressLifeCycle?.id ===
      roomAcceptanceStatusIdsMap.notAccepted
  );
};
